// extracted by mini-css-extract-plugin
module.exports = {"container":"ProjectHelpPage7_container__94OFR","text":"ProjectHelpPage7_text__Zx9Z9","imageExampleSync":"ProjectHelpPage7_imageExampleSync__y0XuE"};